<template>
  <v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
    <v-card-title class="text-h5 pb-2">
      {{ news.title }}
    </v-card-title>
    <v-card-subtitle v-if="news.createdAt || news.created_at" class="pb-2">
      {{ formatDate(news.createdAt || news.created_at) }}
    </v-card-subtitle>
    <v-card-text>
      <v-img
        v-if="news.image"
        :src="getImageUrl(news.image)"
        max-height="300"
        class="mb-4"
      />
      <div class="news-content" v-html="news.content"></div>
    </v-card-text>
    <v-card-actions class="justify-center pb-5">
      <v-btn
        class="white--text"
        style="
          background-color: #d86568;
          width: 150px;
          height: 50px;
          border-radius: 50px;
        "
        @click="handleOk"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { SERVER_URI } from "@/api/NSApi";

export default {
  name: "NewsModal",
  props: {
    news: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getImageUrl(imagePath) {
      if (!imagePath) return "";
      if (imagePath.startsWith("http")) return imagePath;
      if (imagePath.startsWith("/api/uploads")) return imagePath;
      return SERVER_URI + imagePath;
    },
    formatDate(dateString) {
      if (!dateString) return "";
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString("ru-RU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (e) {
        return dateString;
      }
    },
    handleOk() {
      this.$emit("ok", this.news.id);
    },
  },
};
</script>

<style scoped>
.news-content {
  line-height: 1.6;
  font-size: 16px;
}

.news-content :deep(img) {
  max-width: 100%;
  height: auto;
  margin: 10px 0;
}

.news-content :deep(a) {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #1565c0;
  }
}
</style>
